import { WebStorageStateStore } from 'oidc-client-ts'
import type { AuthProviderProps } from 'react-oidc-context'

import { paths } from 'src/router/paths'

export const OIDC_SCOPES = ['openid', 'profile', 'email'] as const

const issuer = import.meta.env.VITE_APP_OIDC_ISSUER
const clientId = import.meta.env.VITE_APP_OIDC_CLIENT_ID
const env = import.meta.env.VITE_APP_ENV

export const assertEnv = (): void => {
  if (!issuer || !clientId) {
    throw new Error(
      'Missing VITE_APP_OIDC_ISSUER or VITE_APP_OIDC_CLIENT_ID — set them in your .env file.'
    )
  }

  if (env !== 'development') {
    const insecureIssuer = !issuer.startsWith('https://')
    const insecureOrigin =
      globalThis.location.protocol === 'http:' &&
      globalThis.location.hostname !== 'localhost'

    if (insecureIssuer) {
      throw new Error(
        `VITE_APP_OIDC_ISSUER must be HTTPS in ${env} (got ${issuer}).`
      )
    }

    if (insecureOrigin) {
      throw new Error(
        `Refusing to run on plain http:// in ${env} — serve over HTTPS.`
      )
    }
  }
}

export const buildOidcConfig = (): AuthProviderProps => ({
  authority: issuer,
  client_id: clientId,
  redirect_uri: `${globalThis.location.origin}${paths.auth.callback}`,
  post_logout_redirect_uri: `${globalThis.location.origin}${paths.auth.login}`,
  response_type: 'code',
  scope: OIDC_SCOPES.join(' '),
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: globalThis.localStorage }),
  automaticSilentRenew: true,
  onSigninCallback: () => {
    globalThis.history.replaceState(
      {},
      document.title,
      globalThis.location.pathname + globalThis.location.hash
    )
  }
})
